module.exports = __webpack_public_path__ + "img/banner-2-mobile.e89a0ceb.png";